import { defineComponent as _defineComponent } from 'vue'
import { inject, onMounted, ref } from "vue";
import dayjs from "dayjs";
import { ISeatInfo } from "@/domain/entities/book";
import { useBookStore } from "@/stores/bookStore";
import SeatsLayout from "./SeatsLayout.vue";
import { PROVIDE_KEY_SHOW_ERROR_MODAL, ShowErrorModal } from "@/types";


const __default__ = {
  name: "SingleBookDateSeat",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  boardDate: {
    type: String,
    default: "",
  },
  seatNo: {
    type: String,
    default: "",
  },
  lineTurnUid: {
    type: String,
    default: "",
  },
  allocUid: {
    type: String,
    default: "",
  },
  isMonthlyBook: {
    type: Boolean,
    deafult: false,
  },
  seatAssignYn: {
    type: Boolean,
    deafult: false,
  },
},
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props;

const showErrorModal = inject(PROVIDE_KEY_SHOW_ERROR_MODAL) as ShowErrorModal;
const bookStore = useBookStore();

const formatDay = (boardDate?: string) => {
  if (props.isMonthlyBook) {
    return boardDate;
  }
  if (boardDate) {
    return boardDate + ` (${getDayOfWeek(boardDate)})`;
  }
  return "";
};

const getDayOfWeek = (boardDate: string) => {
  switch (dayjs(boardDate).day()) {
    case 0:
      return "일";
    case 1:
      return "월";
    case 2:
      return "화";
    case 3:
      return "수";
    case 4:
      return "목";
    case 5:
      return "금";
    case 6:
      return "토";
    default:
      return "";
  }
};

// 좌석 배치도 가져오기
const seatsInfosList = ref<Array<ISeatInfo | undefined>[]>([]);
const seatsRowsNumList = ref<number[]>([]);
const seatsColumnsNumList = ref<number[]>([]);
const mySeatFloor = ref(1);

/** 좌석 정보 조회 */
const getSeatLayout = async (date: string) => {
  const seatLayoutResult = await bookStore.getSeatLayout(
    props.lineTurnUid,
    date,
    false,
    props.allocUid
  );

  if (!seatLayoutResult.isSuccess) {
    showErrorModal(
      "좌석 배치도 조회 오류",
      seatLayoutResult.errorMessage,
      seatLayoutResult.resultCode,
      seatLayoutResult.errorTime
    );
    return;
  }

  seatsInfosList.value = seatLayoutResult.data?.seatLayout ?? [];
  seatsRowsNumList.value = seatLayoutResult.data?.numberOfRows ?? [];
  seatsColumnsNumList.value = seatLayoutResult.data?.numberOfColumns ?? [];

  updateMySeatFloor(props.seatNo);
};

const updateMySeatFloor = (seatNo: string) => {
  seatsInfosList.value.forEach((seatsInfo, index) => {
    const exist = seatsInfo.some((seat) => seat?.seatNo === seatNo);
    if (exist) {
      mySeatFloor.value = index + 1;
    }
  });
};

onMounted(() => {
  if (!props.seatAssignYn) return;

  const date = dayjs(props.boardDate).format("YYYY-MM-DD");
  getSeatLayout(date);
});

const __returned__ = { props, showErrorModal, bookStore, formatDay, getDayOfWeek, seatsInfosList, seatsRowsNumList, seatsColumnsNumList, mySeatFloor, getSeatLayout, updateMySeatFloor, SeatsLayout }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})